import { imagesUrl } from "../../../../shared/config";
import {
  Avatar,
  Typography,
  Grid,
  Box,
  useTheme,
  Divider,
} from "@mui/material";

import { UpdateStudentSituation } from "./UpdateStudentSituations";
import { useStudentEnrollmentData } from "../../api/getStudentEnrollmentData";

const StudentAbout = ({ enrollmentId }) => {
  const theme = useTheme();
  const currentDate = new Date();
  const { data: student } = useStudentEnrollmentData({ enrollmentId });
  const currentElapsedTime = currentDate - student?.dtLiberation;
  const totalTime = student?.dtLimit - student?.dtLiberation;
  const percentageToDeadline =
    typeof currentElapsedTime === "number" && typeof totalTime === "number"
      ? ((100 * currentElapsedTime) / totalTime).toFixed()
      : 0;

  return (
    <Grid
      container
      gap={1}
      sx={{
        width: "100%",

        "& .MuiGrid-item": {
          padding: 1,
          borderRadius: 1,
          // backgroundColor: theme.palette.grey[100],
          // border: `1px solid ${theme.palette.primary.main}`,
        },
      }}
    >
      <Grid item xs="3">
        <div className="flex items-center gap-2">
          <Avatar
            sx={{
              width: "50px",
              height: "50px",
            }}
            src={`${imagesUrl}/${student?.studentId?.image}`}
          />

          <Typography fontWeight={"600"} sx={{ fontSize: "1.3em" }}>
            {student?.studentName}
          </Typography>
        </div>
        <Box
          sx={{
            backgroundColor: theme.palette.grey[200],
            marginTop: 1,
            padding: 1,
          }}
        >
          <Typography>{student?.turma && student?.turma}</Typography>
          <Typography fontWeight={"600"}>{"Matrícula:"}</Typography>
          <Typography>
            {student?.dtLiberation == null
              ? "-"
              : student?.dtLiberation.substring(0, 10).replaceAll("-", "/")}
          </Typography>

          <Typography fontWeight={"600"}>{"Limite: "}</Typography>
          <Typography>
            {student?.dtLimit == null
              ? "-"
              : student?.dtLimit.substring(0, 10).replaceAll("-", "/")}
          </Typography>

          <Typography fontWeight={"600"}>{"Conclusão: "}</Typography>
          <Typography>
            {student?.dtConclusion == null
              ? "-"
              : student?.dtConclusion.substring(0, 10).replaceAll("-", "/")}
          </Typography>
        </Box>
      </Grid>
      <Divider
        orientation="vertical"
        sx={{
          "&::before, &::after": {
            borderColor: "secondary.light",
          },
        }}
      />

      {(student?.situation === "Aguardando Professor" ||
        student?.situation === "Aguardando Aprovação") && (
        <Grid
          item
          xs="4"
          sx={{
            "& form": {
              display: "flex",
              flexDirection: "column",
              gap: 1,
            },
          }}
        >
          <UpdateStudentSituation
            initialValues={{
              grade: student?.finalGrade,
              situation: student?.situation,
            }}
            situation={student?.situation}
            enrollmentId={student?.enrollmentId}
            courseId={student?.courseId}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default StudentAbout;
